import axios from 'axios'
import {
  Loading,
  Message
} from 'element-ui'
import router from '@/router/index'
import store from '@/store/';
import commonMethods from '@/mixins/commonMethods'
import {
  ssoLinkApi
} from '@/settings'

const request = axios.create({
  baseURL: ssoLinkApi, // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  timeout: 10000,
  withCredentials: true
})

// var loadingInstance
// var isLoad = false
var configObj = null

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  console.log(config, 'config')
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  configObj = config
  // 获取保持登录有效期
  // 20240229注释
  // commonMethods.methods.getLocalExpire('logonExpire')
  // 如果type == 1 不显示加载中
  // if (config.type != 1) {
  //   isLoad = true
  // } else {
  //   isLoad = false
  // }
  // isLoad = false
  // if (isLoad) {
  //   let options = {
  //     text: '加载中'
  //   }
  //   loadingInstance = Loading.service(options)
  // }

  // 20240229新增 供其他平台换取ticket接口使用
  let token = localStorage.getItem('token')
  if (token) {
    config.headers['token'] = token; // 设置请求头
  }

  // if (Number(localStorage.getItem('logon')) == 0) {
  //   token = sessionStorage.getItem('token')
  // } else {
  //   token = localStorage.getItem('token')
  // }

  return config
}, error => {
  return Promise.reject(error)
})

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    // if (loadingInstance) {
    //   loadingInstance.close()
    // }
    // if (status === 401) store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
    let token = response.headers['token']
    if (res.code === 200) {
      console.log(configObj, 'configObj token', token)
      // (configObj.url === 'sso/Login' || configObj.url === 'sso/register' || configObj.url === 'sso/wechatLogin') &&
      if (token) {
        console.log(configObj, 'configObj', token, 'token', localStorage.getItem('logon'), 'logon')

        // 20251105 修改
        if (token) {
          // 运维中心时
          if (localStorage.getItem('hrefPage') === 'service') {
            // 解决不能实时取到token缓存问题
            store.state.user.operationCenterToken = token
            localStorage.setItem('operationCenterToken', token || '')
            console.log(localStorage.getItem('operationCenterToken'), store.state.user.operationCenterToken,
              'operationCenterToken')
          } else {
            // 其他平台时
            // 解决不能实时取到token缓存问题
            store.state.user.token = token
            localStorage.setItem('token', token || '')
            console.log(localStorage.getItem('token'), store.state.user.token, 'token')
          }

          // if (Number(localStorage.getItem('logon')) == 0) {
          //   sessionStorage.setItem('token', token || '')
          // } else {
          //   localStorage.setItem('token', token || '')
          // }
        }
      }
      return res
      // reslove(res.data, res)
    } else if (res.code === 401) {
      // 重置登录状态
      commonMethods.methods.resetLogin()
    }
    return res
  },
  error => {
    // loadingInstance.close()
    Message.error('网络错误，请重新加载')
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/axios.js